import React from 'react';
import { Icon } from 'antd';
import { Loading } from './Loading.styles';
var LoadingCmp = function (_a) {
    var theme = _a.theme;
    return (React.createElement(Loading, null,
        React.createElement(Icon, { type: "loading", style: { color: theme.type === 'dark' ? 'rgba(255,255,255, 0.35)' : 'rgba(0,0,0, 0.35)', fontSize: '60px' } })));
};
export default LoadingCmp;
